export default class DebugLog {
  // ※ログの呼び出し元がこのファイルになってしまうので要注意

  constructor(level = 1) {
    this.debugLevel = level
    const host = location.host
    if (host === '192.168.10.10' || /^localhost/.test(host)){
      this.branch = 'local'
    } else if (/^dev\.uranai\.tv$/.test(host)) {
      this.branch = 'dev'
    } else if (/^stg\.uranai\.tv$/.test(host)) {
      this.branch = 'stg'
    } else {
      this.branch = 'prod'
    }
  }

  /**
   * ログ出力
   * @param val
   * @param args
   */
  log(val, ...args) {
    if (this.checkEnable()) {
      console.log(val, ...args)
    }
  }

  /**
   * インフォ (デバッグ判定しない -> 常に出力)
   * @param val
   * @param args
   */
  info(val, ...args) {
    //通常のconsole.infoではないので注意
    if (this.checkEnable()) {
      console.log(`%c${val}`, 'color:blue;', ...args)
    }
  }

  /**
   * ワーニング (デバッグ判定しない -> 常に出力) ※使わない
   * @param val
   * @param args
   */
  warn(val, ...args) {
    console.warn(val, ...args)
  }

  /**
   * エラー (デバッグ判定しない -> 常に出力) ※使わない
   * @param val
   * @param args
   */
  error(val, ...args) {
    console.error(val, ...args)
  }

  /**
   * DOM展開
   * @param obj
   */
  dir(obj) {
    if (this.checkEnable()) {
      console.dir(obj)
    }
  }

  /**
   * DOM展開XML
   * @param obj
   */
  dirxml(obj) {
    if (this.checkEnable()) {
      console.dirxml(obj)
    }
  }

  /**
   * スタックトレース
   * @param val
   * @param args
   */
  trace(val, ...args) {
    if (this.checkEnable()) {
      console.trace(val, ...args)
    }
  }

  /**
   * アサーション
   * @param assertion
   * @param args
   */
  assert(assertion, ...args) {
    if (this.checkEnable()) {
      console.assert(assertion, ...args)
    }
  }

  /**
   * カウント
   * @param label
   */
  count(label) {
    if (this.checkEnable()) {
      console.count(label)
    }
  }

  /**
   * カウントリセット
   * @param label
   */
  countReset(label) {
    if (this.checkEnable()) {
      console.countReset(label)
    }
  }

  /**
   * クリア
   */
  clear() {
    if (this.checkEnable()) {
      console.clear()
    }
  }

  /**
   * グループ化
   * @param label
   */
  group(label) {
    if (this.checkEnable()) {
      console.group(label)
    }
  }

  /**
   * グループ化閉じ
   */
  groupEnd() {
    if (this.checkEnable()) {
      console.groupEnd()
    }
  }

  /**
   * テーブル出力
   * @param args
   */
  table(...args) {
    if (this.checkEnable()) {
      console.table(...args)
    }
  }

  /**
   * 時間計測開始
   * @param label
   */
  time(label) {
    if (this.checkEnable()) {
      console.time(label)
    }
  }

  /**
   * 途中の時間出力
   * @param label
   */
  timeLog(label) {
    if (this.checkEnable()) {
      console.time(label)
    }
  }

  /**
   * 時間計測終了
   * @param label
   */
  timeEnd(label) {
    if (this.checkEnable()) {
      console.timeEnd(label)
    }
  }

  /**
   * タイムスタンプ出力
   * @param label
   */
  timeStamp(label) {
    if (this.checkEnable()) {
      console.timeStamp(label)
    }
  }

  checkEnable() {
    //一旦ブランチを判定するだけ
    switch (this.branch) {
      case 'local':
        return true
      case 'dev':
        return true
      case 'stg':
        return this.debugLevel === 2
      case 'prod':
        return false
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/utils/DebugLog.js